import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { matchFilterNumber, sortArrayBy } from '@domain-group/javascript-utils'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

const watchEntityKeys = ['publicationOptions']

type PublicationOptionFilters = {
  publication_id?: number,
}

type UsePublicationOptionsOptions = {
  entityKey?: string,
  filters?: PublicationOptionFilters,
  performHttpRequests?: boolean,
  requestOptions?: object,
}

function usePublicationOptions(options: UsePublicationOptionsOptions = {}) {
  const { entityKey, filters, performHttpRequests } = options
  const {
    publication_id: filterPublicationId,
  } = filters || {}

  const {
    updatedEntities: { publicationOptions: publicationOptionsUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { loading: loadingPublicationOptions } = useReduxAction(
    'publicationOptions',
    'loadPublicationOptions',
    {
      ...defaultRequestOptions.publicationOption,
      ...filters,
      entityKey,
    },
    [filters, performHttpRequests],
    {
      // @ts-expect-error TS2322
      shouldPerformFn: ({ loading }) => performHttpRequests && !loading,
    },
  )

  // @ts-expect-error TS18046
  const publicationOptions = useSelector(reduxState => reduxState.entities.publicationOptions)

  const filteredPublicationOptions = useMemo(() => {
    const filtered = Object.values(publicationOptions).filter((option) => {
      // @ts-expect-error TS2339
      const { publication_id } = option

      const matchPublication = matchFilterNumber(publication_id, filterPublicationId)

      return matchPublication
    })

    return sortArrayBy(filtered, 'asc')
  }, [publicationOptionsUpdatedAt, JSON.stringify(filters)])

  const hasFilteredPublicationOptions = !!filteredPublicationOptions.length

  return {
    filteredPublicationOptions,
    hasFilteredPublicationOptions,
    loading: loadingPublicationOptions,
    publicationOptions,
    publicationOptionsUpdatedAt,
  }
}

export default usePublicationOptions
